function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M24.865 61.832l16.157-5.21M21.136 49.654l5.4-1.741",
  stroke: "#4D4D4D",
  strokeWidth: 2.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M39.795 57.018l14.414-4.65a4.736 4.736 0 003.28-4.506C57.488 33.901 42.342 10 42.342 10L13 19.466s15.145 23.9 15.145 37.862a4.733 4.733 0 01-9.417.675l-1.035-7.24 4.489-1.448",
  stroke: "#4D4D4D",
  strokeWidth: 2.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M17.923 37.13a140.23 140.23 0 00-3.976-8.199M20.28 41.895c-.212-.535-.43-1.07-.654-1.605M52.755 19.466c1.702 3.175 3.602 6.965 5.318 10.955M49.916 14.733c.276.486.567 1 .867 1.54M57.488 55.923L59 55.435M42.343 61.195l11.987-3.867M23.412 24.198l17.985-5.679M26.252 29.878l17.985-5.68M29.092 35.557l17.984-5.68M30.985 41.236l17.984-5.679M45.334 47.803l6.22-2.007M37.61 50.264l1.575-.509",
  stroke: "#4D4D4D",
  strokeWidth: 2.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

function SvgBill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3);
}

export default __webpack_public_path__ + "/img/bill.svg";
export { SvgBill as ReactComponent };